import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {FinancialReportComponent} from "./components/financial-report/financial-report.component";
import {HttpClientModule} from "@angular/common/http";
import { FinancialsComponent } from './financials.component';

const financialsRoutes: Routes = [
   {
    path: '',
    component: FinancialsComponent,
  },
  // {
  //   path: '',
  //   component: FinancialReportComponent,
  // },
  // {
  //   path: 'provider',
  //   component: FinancialsComponent,
  // },
];

@NgModule({
  imports: [RouterModule.forChild(financialsRoutes), HttpClientModule],
  exports: [RouterModule]
})
export class FinancialsRoutingModule { }
